<!--
  Angular 15: *ngIf / *ngFor only, no @if blocks.
-->
<div class="dl-page">

  <div class="dl-page__header">
    <div class="dl-page__heading">
      <h1 class="dl-page__title">Subscriptions</h1>
      <p class="dl-page__subtitle">
        What each lab bought. A new lab can do nothing until approved here, and its owner is emailed the
        answer. Marking one paid switches on its modules that wait for payment. Labs ask support to change plan.
      </p>
    </div>
    <div class="dl-page__actions">
      <a class="dl-btn" routerLink="/plans" data-testid="subscriptions-plans-link">
        <mat-icon>sell</mat-icon>
        Plans and prices
      </a>
    </div>
  </div>

  <div class="subs-filters">
    <select class="dl-input subs-filter" [(ngModel)]="filter" data-testid="subscriptions-status">
      <option value="PENDING">Waiting for approval</option>
      <option value="ALL">All</option>
      <option value="UNPAID">Unpaid</option>
      <option value="PAID">Paid</option>
    </select>
    <label class="subs-check">
      <input type="checkbox" [(ngModel)]="overdueOnly" data-testid="subscriptions-overdue"> Overdue only
    </label>
  </div>

  <div class="dl-loading" *ngIf="loading">
    <div class="dl-spinner"></div>
    <p>Loading…</p>
  </div>

  <div class="dl-banner dl-banner--error" *ngIf="error">
    <mat-icon>error</mat-icon>
    <div class="dl-banner__body">{{ error }}</div>
    <div class="dl-banner__actions">
      <button type="button" class="dl-btn dl-btn--sm" (click)="load()">Try again</button>
    </div>
  </div>

  <p *ngIf="!loading && !error && !shown.length" data-testid="subscriptions-empty">No subscriptions here.</p>

  <div class="dl-card subs-table" *ngIf="!loading && !error && shown.length">
    <table>
      <thead>
        <tr>
          <th>Lab</th><th>Plan</th><th>Period</th><th>Price</th><th>From</th><th>To</th><th>Status</th><th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let subscription of shown" [attr.data-testid]="'subscription-' + subscription.id"
            [attr.data-status]="subscription.paymentStatus">
          <td>
            <a [routerLink]="['/partners', subscription.tenantId]">{{ subscription.tenantName }}</a>
            <span class="subs-tag" *ngIf="subscription.selfService">self-service</span>
          </td>
          <td>{{ subscription.kind === 'FLEXIBLE' ? 'Flexible' : subscription.planName }}</td>
          <td>{{ subscription.billingPeriod === 'YEARLY' ? 'Yearly' : 'Monthly' }}</td>
          <td>€{{ subscription.price | number:'1.2-2' }}</td>
          <td>{{ subscription.periodStart | date:'dd.MM.yyyy' }}</td>
          <td>{{ subscription.periodEnd | date:'dd.MM.yyyy' }}</td>
          <td>
            {{ subscription.paymentStatus === 'PAID' ? 'Paid' : 'Unpaid' }}
            <span class="subs-tag subs-tag--warn" *ngIf="subscription.approvalStatus === 'PENDING'">waiting for approval</span>
            <span class="subs-tag" *ngIf="subscription.approvalStatus === 'REJECTED'">rejected</span>
            <span class="subs-tag subs-tag--warn" *ngIf="subscription.overdue">overdue</span>
            <span class="subs-tag subs-tag--warn" *ngIf="subscription.renewalDue">renewal due</span>
            <span class="subs-tag subs-tag--warn" *ngIf="subscription.pastPeriod" data-testid="subscription-past-period">past period, owed</span>
          </td>
          <td class="subs-actions">
            <button type="button" class="dl-btn dl-btn--sm dl-btn--primary" *ngIf="subscription.approvalStatus === 'PENDING'"
                    (click)="approve(subscription)" [disabled]="busy === subscription.id"
                    [attr.data-testid]="'subscription-approve-' + subscription.id">Approve</button>
            <button type="button" class="dl-btn dl-btn--sm" *ngIf="subscription.approvalStatus === 'PENDING'"
                    (click)="reject(subscription)" [disabled]="busy === subscription.id"
                    [attr.data-testid]="'subscription-reject-' + subscription.id">Reject</button>
            <button type="button" class="dl-btn dl-btn--sm" *ngIf="subscription.approvalStatus === 'APPROVED' && !subscription.pastPeriod"
                    (click)="startChange(subscription)" [attr.data-testid]="'subscription-change-' + subscription.id">Change plan</button>
            <button type="button" class="dl-btn dl-btn--sm dl-btn--primary" *ngIf="subscription.paymentStatus === 'UNPAID'"
                    (click)="markPaid(subscription)" [disabled]="busy === subscription.id"
                    [attr.data-testid]="'subscription-mark-paid-' + subscription.id">Mark paid</button>
            <button type="button" class="dl-btn dl-btn--sm" *ngIf="subscription.paymentStatus === 'PAID'"
                    (click)="markUnpaid(subscription)" [disabled]="busy === subscription.id">Mark unpaid</button>
            <button type="button" class="dl-btn dl-btn--sm" *ngIf="subscription.renewalDue"
                    (click)="renew(subscription)" [disabled]="busy === subscription.id"
                    [attr.data-testid]="'subscription-renew-' + subscription.id">Renew</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="dl-card subs-change" *ngIf="changing" data-testid="subscription-change-panel">
    <h2 class="subs-change__title">Change plan: {{ changing.tenantName }}</h2>
    <p>Applies at once and the new plan starts unpaid, so modules that wait for payment go off until it is marked paid.</p>
    <div class="subs-filters">
      <select class="dl-input subs-filter" [(ngModel)]="changeKind" data-testid="subscription-change-kind">
        <option value="FIXED">Fixed plan</option>
        <option value="FLEXIBLE">Flexible</option>
      </select>
      <select class="dl-input subs-filter" *ngIf="changeKind === 'FIXED'" [(ngModel)]="changePlan" data-testid="subscription-change-plan">
        <option *ngFor="let plan of plans" [value]="plan.code">{{ plan.name }}</option>
      </select>
      <select class="dl-input subs-filter" [(ngModel)]="changePeriod" data-testid="subscription-change-period">
        <option value="MONTHLY">Monthly</option>
        <option value="YEARLY">Yearly</option>
      </select>
    </div>
    <div *ngIf="changeKind === 'FLEXIBLE'" class="subs-filters subs-change__modules">
      <label class="subs-check" *ngFor="let module of modules">
        <input type="checkbox" [checked]="changeModules.includes(module.featureFlag!)"
               (change)="toggleChangeModule(module.featureFlag!, $any($event.target).checked)"> {{ module.name }}
      </label>
    </div>
    <div class="subs-actions">
      <button type="button" class="dl-btn dl-btn--sm" (click)="changing = null">Cancel</button>
      <button type="button" class="dl-btn dl-btn--sm dl-btn--primary" (click)="saveChange()" [disabled]="busy === changing.id"
              data-testid="subscription-change-save">Change plan</button>
    </div>
  </div>
</div>
